<app-error-page-layout>
  <img alt="" class="mx-auto mb-6 h-44 dark:hidden" src="images/not_found.svg" />
  <img alt="" class="mx-auto mb-6 hidden h-44 dark:block" src="images/not_found_dark.svg" />

  <p
    class="mb-3 text-8xl leading-none font-extrabold text-zinc-200 tabular-nums dark:text-zinc-700">
    404
  </p>

  <h1 class="mb-2">{{ 'error_pages.not_found.title' | translate }}</h1>
  <p class="text-text-secondary mb-8">
    {{ 'error_pages.not_found.description' | translate }}
  </p>

  <a href="/" class="btn-primary inline-flex items-center gap-2 rounded-sm px-5 py-2.5">
    <i class="ph-bold ph-house"></i>
    {{ 'error_pages.redirect' | translate }}
  </a>
</app-error-page-layout>
